
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.044 5.542V11h7.978a2.027 2.027 0 012.022 2.018v3.956a2.027 2.027 0 01-2.022 2.021V19h-7.978v5.46c0 1.3-.82 1.9-1.821 1.313L1.712 16.251a1.46 1.46 0 010-2.507l15.511-9.518a1.482 1.482 0 01.739-.225c.636-.001 1.082.573 1.082 1.541z","fill":"#990ae3","stroke":"rgba(0,0,0,0)"}})])
          )
        }
      }
    